import React from 'react'
import * as PosService from '../../Services/pos-service'
import { t } from 'i18next';

function PosRequestConfirmButton({ objectDto, term, setLoading, setObjectDto, listFile, setValidate }) {
    return (
        <>
            <div className="footer-box-bg col-md-12 form-group description-small-customer" id="warning" style={{ color: "red", display: "none", textAlign: "center" }}>
                <span> Hệ thống đang cập nhật dữ liệu, vui lòng KHÔNG tắt trình duyệt hoặc refresh lại trang.</span>
            </div>
            <div className="col-md-12" id="submitDiv" hidden={!(objectDto.checked === 1 && objectDto.saved === 0)} style={{ marginBottom: "5%" }}>{/* Button */}
                <label className="col-md-12 description-small-customer" style={{ color: "red" }}>
                    * Quý khách vui lòng điền đầy đủ thông tin ở trên và chọn thông tin cần thay đổi.
                </label>
                <label className="col-md-12 description-small-customer" style={{ color: "red" }}>
                    * Khai báo chính xác thông tin cần thay đổi tương ứng với nội dung đã chọn thay đổi ở trên trước khi "GỬI YÊU CẦU".
                </label>
                <div className="col-md-12">
                    <a id="btnClose" className="btn-common btn-search description-small-customer"
                        onClick={() => {
                            setLoading(true);
                            PosService.HandleClose(setObjectDto, setLoading);
                        }}>
                        <i className="fa fa-ban" aria-hidden="true" style={{ marginRight: "5px" }} />
                        <span>
                            {t('buttonclose').toUpperCase()}
                        </span>
                    </a>
                    <a id="btnSubmit" className={term === true ? "btn-common btn-search description-small-customer" : "btn-common btn-search disable description-small-customer"}
                        onClick={(e) => {
                            setLoading(true);
                            PosService.HandleSubmitRequest(objectDto, setObjectDto, listFile, setLoading, setValidate);
                        }}>
                        <i className="fa fa-paper-plane" aria-hidden="true" style={{ marginRight: "5px" }} />
                        <span>
                            {t('buttonsubmit').toUpperCase()}
                        </span>
                    </a>
                </div>
            </div>
        </>
    )
}
export default PosRequestConfirmButton